import { combineReducers } from 'redux';
import { reducer as form } from 'redux-form';

import accoladeTypeRatings from '@tock/shared/state/accoladeTypeRatings';
import accoladeTypes from '@tock/shared/state/accoladeTypes';
import app from 'state/app';
import bank from 'state/bank';
import business from 'state/business';
import businessGroups from 'state/businessGroups';
import businesses from 'state/businesses';
import consumerPage from 'state/consumerPage';
import feature from 'state/feature';
import features from 'state/features';
// import financialReports from 'state/financialReports';
import { reducer as toast } from '@tock/toast';
import importReport from 'state/importReport';
import importer from 'state/importer';
import metroArea from 'state/metroArea';
import onboarding from 'state/onboarding';
import partners from 'state/partners';
import patrons from 'state/patrons';
import phoneNumberAllocation from 'state/phoneNumberAllocation';
import scheduleHistory from 'state/scheduleHistory';
import serviceEvents from 'state/serviceEvents';
import verifications from 'state/verifications';

export const reducers = {
  accoladeTypes,
  accoladeTypeRatings,
  app,
  bank,
  business,
  businesses,
  businessGroups,
  consumerPage,
  feature,
  features,
  // financialReports,
  form,
  importer,
  importReport,
  metroArea,
  onboarding,
  partners,
  patrons,
  phoneNumberAllocation,
  scheduleHistory,
  serviceEvents,
  verifications,
  toast,
};

export default combineReducers(reducers);
